(() => {
  const SELECTORS = {
    menu: '[data-lucid-site-menu]',
    open: '[data-lucid-menu-open]',
    close: '[data-lucid-menu-close]',
    drawer: '[data-lucid-menu-drawer]',
    overlay: '[data-lucid-menu-overlay]',
    back: '[data-lucid-back-control]'
  };

  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initMenu(menu) {
    const openButton = menu.querySelector(SELECTORS.open);
    const closeButton = menu.querySelector(SELECTORS.close);
    const drawer = menu.querySelector(SELECTORS.drawer);
    const overlay = menu.querySelector(SELECTORS.overlay);
    if (!openButton || !closeButton || !drawer || !overlay) return;

    let lastFocused = null;

    const openMenu = () => {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        overlay.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lucid-menu-open');
      closeButton.focus({ preventScroll: true });
    };

    const closeMenu = () => {
      overlay.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lucid-menu-open');
      window.setTimeout(() => { overlay.hidden = true; }, 310);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
    drawer.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((el) => !el.hasAttribute('hidden'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initBackControl(button) {
    const revealAt = 560;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateVisibility = () => {
      const visible = window.scrollY > revealAt;
      button.hidden = false;
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    button.addEventListener('click', () => {
      const preferred = button.dataset.preferredTarget;
      const productCards = document.querySelector('#lucid-product-cards');
      let destination = 0;

      if (preferred === 'product_cards' && productCards) {
        const targetTop = productCards.getBoundingClientRect().top + window.scrollY;
        // When the visitor is below the offers, return to the offer cards. If already
        // above or close to them, return to the true top instead.
        if (window.scrollY > targetTop + 260) destination = targetTop;
      }

      window.scrollTo({ top: Math.max(0, destination), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
  }

  const boot = () => {
    document.querySelectorAll(SELECTORS.menu).forEach(initMenu);
    document.querySelectorAll(SELECTORS.back).forEach(initBackControl);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
